/*
  ADA / WCAG 2.4.3 + 4.1.2 (2026-09-30): keep off-screen carousel cells out of
  the keyboard tab order, and only those.

  Flickity marks every non-selected cell aria-hidden="true", including the
  neighbouring cells that are fully visible in multi-cell sliders (press
  logos, before/after, UGC). Links inside those cells stayed tabbable: keyboard
  users landed on links they could not see, and screen readers skipped links
  they could. Hiding everything aria-hidden would have broken the visible
  neighbours, so visibility is decided by geometry instead: a cell counts as
  visible when it sits inside the carousel's viewport (with a 1px tolerance).

  Off-screen cells: aria-hidden="true", focusable descendants get
  tabindex="-1" (original value remembered). Visible cells: aria-hidden
  removed, tabindex restored. Re-evaluated whenever Flickity moves the slider,
  toggles aria-hidden, or the window resizes.
*/
(function () {
  var FOCUSABLE = 'a[href], button, input, select, textarea, [tabindex]';
  var pending = false;

  function updateCarousel(carousel) {
    var viewport = carousel.querySelector('.flickity-viewport') || carousel;
    var box = viewport.getBoundingClientRect();
    if (!box.width) return;
    var cells = carousel.querySelectorAll('.carousel-cell, .flickity-slider > *');
    for (var i = 0; i < cells.length; i++) {
      var cell = cells[i];
      var r = cell.getBoundingClientRect();
      var visible = r.right > box.left + 1 && r.left < box.right - 1;
      if (visible) {
        if (cell.getAttribute('aria-hidden') === 'true') cell.removeAttribute('aria-hidden');
      } else if (cell.getAttribute('aria-hidden') !== 'true') {
        cell.setAttribute('aria-hidden', 'true');
      }
      var focusables = cell.querySelectorAll(FOCUSABLE);
      for (var j = 0; j < focusables.length; j++) {
        var el = focusables[j];
        if (visible) {
          if (el.hasAttribute('data-ada-tabindex')) {
            var original = el.getAttribute('data-ada-tabindex');
            if (original === '') el.removeAttribute('tabindex');
            else el.setAttribute('tabindex', original);
            el.removeAttribute('data-ada-tabindex');
          }
        } else if (!el.hasAttribute('data-ada-tabindex')) {
          el.setAttribute('data-ada-tabindex', el.getAttribute('tabindex') || '');
          el.setAttribute('tabindex', '-1');
        }
      }
    }
  }

  function updateAll() {
    pending = false;
    var carousels = document.querySelectorAll('.flickity-enabled');
    for (var i = 0; i < carousels.length; i++) updateCarousel(carousels[i]);
  }

  function schedule() {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(updateAll);
  }

  function init() {
    schedule();
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('load', schedule);
    // Flickity animates by rewriting style on .flickity-slider and toggles
    // aria-hidden on cells; both are attribute mutations.
    new MutationObserver(schedule).observe(document.body, {
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'aria-hidden', 'class'],
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
